"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventClient = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var constants_1 = require("./constants");
var externalServices_1 = require("./utils/externalServices");
var util_1 = require("./utils/util");
var EventClient = (function () {
    function EventClient(options) {
        this.options = options;
        this.tagCalled = false;
        if (this.options.autoPageView === undefined) {
            this.options.autoPageView = true;
        }
        externalServices_1.loadTagManager(this.options.trackingId);
        this.tagCalled = true;
        this.pushDataLayer(__assign({ event: 'Init' }, options));
    }
    Object.defineProperty(EventClient.prototype, "dataLayer", {
        get: function () {
            if (!this.tagCalled) {
                window.dataLayer = window.dataLayer || [];
            }
            return window.dataLayer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventClient.prototype, "ruid", {
        get: function () {
            var ruid = js_cookie_1.default.get('ruid') || undefined;
            return ruid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventClient.prototype, "uId", {
        get: function () {
            return this.options.uId;
        },
        enumerable: false,
        configurable: true
    });
    EventClient.prototype.setFfid = function (ffid) {
        this.options.ffid = ffid;
        this.pushDataLayer(__assign({ event: 'FfidChanged' }, this.options));
    };
    EventClient.prototype.setUId = function (uId) {
        this.options.uId = uId;
        this.pushDataLayer(__assign({ event: 'UIdChanged' }, this.options));
    };
    EventClient.prototype.sendEvent = function (name, data, ts) {
        if (data === void 0) { data = {}; }
        data = util_1.convertKeyToSnakeCase(data);
        if (!ts) {
            ts = new Date();
        }
        var dataLayerValues = {
            event: name,
            event_params: __assign(__assign({}, data), { uId: this.options.uId }),
            ts: ts.getTime(),
        };
        if (this.options.debug) {
            console.group("[@ridi/ridi-event-client] Sending '" + name + "' event");
            Object.entries(dataLayerValues).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                console.log(key + "\t " + JSON.stringify(value));
            });
            console.groupEnd();
        }
        this.pushDataLayer(dataLayerValues);
    };
    EventClient.prototype.isInitialized = function () {
        return this.tagCalled;
    };
    EventClient.prototype.sendPageView = function (ts) {
        if (this.options.autoPageView) {
            throw new Error('[@ridi/ridi-event-client] autoPageView option enabled. Do not call this method manually');
        }
        this.sendEvent('PageView', {}, ts);
    };
    EventClient.prototype.sendScreenView = function (screenClass, screenName, previousScreenName, ts) {
        this.sendEvent('ScreenView', { screenName: screenName, screenClass: screenClass, previousScreenName: previousScreenName }, ts);
    };
    EventClient.prototype.sendSignUp = function (ts) {
        this.sendEvent('SignUp', { method: constants_1.LoginMethod.WEB }, ts);
    };
    EventClient.prototype.sendLogin = function (ts) {
        this.sendEvent('Login', { method: constants_1.LoginMethod.WEB }, ts);
    };
    EventClient.prototype.sendBeginCheckout = function (items, ts) {
        this.sendEvent('BeginCheckout', { items: items }, ts);
    };
    EventClient.prototype.sendAddPaymentInfo = function (purchaseInfo, ts) {
        this.sendEvent('AddPaymentInfo', purchaseInfo, ts);
    };
    EventClient.prototype.sendEnrollPreference = function (items, ts) {
        this.sendEvent('EnrollPreference', { items: items }, ts);
    };
    EventClient.prototype.sendUnenrollPreference = function (items, ts) {
        this.sendEvent('UnenrollPreference', { items: items }, ts);
    };
    EventClient.prototype.sendEnrollNewBookNotification = function (items, ts) {
        this.sendEvent('EnrollNewBookNotification', { items: items }, ts);
    };
    EventClient.prototype.sendUnenrollNewBookNotification = function (items, ts) {
        this.sendEvent('UnenrollNewBookNotification', { items: items }, ts);
    };
    EventClient.prototype.sendViewItem = function (items, ts) {
        this.sendEvent('ViewItem', { items: items }, ts);
    };
    EventClient.prototype.sendViewContent = function (item, ts) {
        this.sendEvent('ViewContent', __assign({}, item), ts);
    };
    EventClient.prototype.sendPurchase = function (transactionId, purchaseInfo, ts) {
        this.sendEvent('Purchase', __assign({ transactionId: transactionId }, purchaseInfo), ts);
    };
    EventClient.prototype.sendUserAttribute = function (key, attr, ts) {
        this.sendEvent('UserAttribute', { key: key, attr: attr }, ts);
    };
    EventClient.prototype.sendCustomEvent = function (eventName, params, ts) {
        this.sendEvent('CustomEvent', __assign({ eventName: eventName }, params), ts);
    };
    EventClient.prototype.sendAddToCart = function (items, ts) {
        this.sendEvent('AddToCart', { items: items }, ts);
    };
    EventClient.prototype.sendRemoveFromCart = function (items, ts) {
        this.sendEvent('RemoveFromCart', { items: items }, ts);
    };
    EventClient.prototype.sendAddToWish = function (items, ts) {
        this.sendEvent('AddToWish', { items: items }, ts);
    };
    EventClient.prototype.sendRemoveFromWish = function (items, ts) {
        this.sendEvent('RemoveFromWish', { items: items }, ts);
    };
    EventClient.prototype.sendCartToWishlist = function (items, ts) {
        this.sendEvent('CartToWishlist', { items: items }, ts);
    };
    EventClient.prototype.sendWishlistToCart = function (items, ts) {
        this.sendEvent('WishlistToCart', { items: items }, ts);
    };
    EventClient.prototype.sendAddRidiPayCard = function (previousScreenName, ts) {
        this.sendEvent('AddRidiPayCard', { previousScreenName: previousScreenName }, ts);
    };
    EventClient.prototype.sendCheckoutRidiPay = function (ridiPayType, ts) {
        this.sendEvent('CheckoutRidiPay', { ridiPayType: ridiPayType }, ts);
    };
    EventClient.prototype.pushDataLayer = function (data) {
        if (!this.tagCalled) {
            console.warn('[@ridi/ridi-event-client] GTM is not initialized.');
        }
        this.dataLayer.push(data);
    };
    return EventClient;
}());
exports.EventClient = EventClient;
//# sourceMappingURL=eventClient.js.map


// WEBPACK FOOTER //
// /static/node_modules/@ridi/event-client/dist/cjs/eventClient.js